import { Typography, Box, Grid, Stack, Button } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import MailIcon from "@mui/icons-material/Mail";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { openWhatsApp } from "../components/contact_sources";
import { useInView } from "../components/hook";
import { CONTACT_INFO } from "../components/commanDetails";


export default function Contact() {
  const [ref, show] = useInView(0.3);
  const openLocation = () => {
  window.open(
    "https://maps.app.goo.gl/dXee4piGG4tNyMcG7",
    "_blank"
  );
};
  return (
    <Box ref={ref} sx={{ width: "100%", background: "#f7f4ec" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "Center",
          alignItems: "Center",
          flexDirection: "column",

          gap: 4,
          p: 2.62,
        }}
      >
        <Box
          sx={{
            display: "flex",
            height: "30px",
            width: "120px",
            bgcolor: "#faf1e3",
            borderRadius: "20px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography sx={{ fontWeight: 600, color: "#e99e26ff" }}>
            Get in Touch
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h2" sx={{ fontSize: "50px", fontWeight: 700 }}>
            Let's Create Something
          </Typography>
          <Typography
            variant="h2"
            sx={{ color: "#e99e26ff", fontSize: "50px", fontWeight: 700 }}
          >
            Sweet Together
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: "17px",
            color: "#595959ff",
            maxWidth: "700px",
            textAlign: "center",
          }}
        >
          Have a special occasion coming up? Custom cake request? Or just want
          to say hello? We'd love to hear from you!
        </Typography>
        <Grid container sx={{ minHeight: "221px" }} spacing={3}>
          <Grid item size={{ xs: 12, md: 3 }}>
            <Box
             onClick={openLocation}
              sx={{
                borderRadius: "15px",
                p: 3,
                background: "white",
                display: "flex",

                cursor: "pointer",
                boxShadow: "0 5px 12px rgba(0,0,0,0.08)",
                opacity: show ? 1 : 0,
                transform: show
                  ? "scale(1) translateY(0)"
                  : "scale(0.88) translateY(25px)",
                transition: "all 0.55s ease",
                transitionDelay: "0.12s",

                "&:hover": {
                  transform: "translateY(-5px)", // little pop up
                  boxShadow: "0 12px 30px rgba(247, 206, 149, 0.8)",
                },

                "&:hover .icon-box": {
                  transform: "scale(1.12)",
                  bgcolor: "#ffe3b5ff",
                },

                //   "&:hover .icon": {
                //     transform: "scale(1.15)",
                //   },

                "&:hover .title": {
                  color: "#F29C24",
                },
              }}
            >
              <Stack sx={{ display: "flex" }} spacing={2}>
                <Box
                  className="icon-box"
                  sx={{
                    height: "60px",
                    width: "60px",
                    background: "linear-gradient(104deg, #f09823, #d87113)",
                    borderRadius: "15px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: "all 0.3s ease",
                  }}
                >
                  <LocationOnOutlinedIcon
                    className="icon"
                    sx={{
                      color: "white",
                      fontSize: 30,
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Box>
                <Typography
                  className="title"
                  variant="h5"
                  sx={{
                    fontSize: "19px",
                    fontWeight: 800,
                    transition: "color 0.3s ease",
                  }}
                >
                  Visit Us
                </Typography>
                <Box>
                  <Typography
                    sx={{
                      color: "#595959ff",
                      fontSize: "13px",
                      mt: 1,
                      maxWidth: "90%",
                    }}
                  >
                    Oppo.  Community Hall
                  </Typography>
                  <Typography sx={{ color: "#595959ff", fontSize: "13px" }}>
                    Kunthipuzha,Mannarakkad
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Grid>
          <Grid item size={{ xs: 12, md: 3 }}>
            <Box
              sx={{
                borderRadius: "15px",
                p: 3,
                background: "white",
                display: "flex",
                cursor: "pointer",
                boxShadow: "0 5px 12px rgba(0,0,0,0.08)",
                transition: "all 0.3s ease",
                opacity: show ? 1 : 0,
                transform: show
                  ? "scale(1) translateY(0)"
                  : "scale(0.88) translateY(25px)",
                
                transitionDelay: "0.24s",

                "&:hover": {
                  transform: "translateY(-5px)", // little pop up
                  boxShadow: "0 12px 30px rgba(247, 206, 149, 0.8)",
                },

                "&:hover .icon-box": {
                  transform: "scale(1.12)",
                  bgcolor: "#ffe3b5ff",
                },

                //   "&:hover .icon": {
                //     transform: "scale(1.15)",
                //   },

                "&:hover .title": {
                  color: "#F29C24",
                },
              }}
            >
              <Stack sx={{}} spacing={2}>
                <Box
                  className="icon-box"
                  sx={{
                    height: "60px",
                    width: "60px",
                    background: "linear-gradient(104deg, #f09823, #d87113)",
                    borderRadius: "15px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: "all 0.3s ease",
                  }}
                >
                  <PhoneIcon
                    className="icon"
                    sx={{ fontSize: 30, color: "white" }}
                  />
                </Box>
                <Typography
                  className="title"
                  variant="h5"
                  sx={{
                    fontSize: "19px",
                    fontWeight: 800,
                    transition: "color 0.3s ease",
                  }}
                >
                  Call Us
                </Typography>
                <Box>
                  <Typography
                    sx={{ color: "#595959ff", fontSize: "14px", mt: 1 }}
                  >
                    {CONTACT_INFO.phone}
                  </Typography>
                  <Typography sx={{ color: "#595959ff", fontSize: "14px" }}>
                    orders@caramelcottage.com
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Grid>
          <Grid item size={{ xs: 12, md: 3 }}>
            <Box
              sx={{
                borderRadius: "15px",
                p: 3,
                background: "white",
                display: "flex",
                cursor: "pointer",
                boxShadow: "0 5px 12px rgba(0,0,0,0.08)",
                
                opacity: show ? 1 : 0,
                transform: show
                  ? "scale(1) translateY(0)"
                  : "scale(0.88) translateY(25px)",
                transition: "all 0.55s ease",
                transitionDelay: "0.36s",

                "&:hover": {
                  transform: "translateY(-5px)", // little pop up
                  boxShadow: "0 12px 30px rgba(247, 206, 149, 0.8)",
                },

                "&:hover .icon-box": {
                  transform: "scale(1.12)",
                  bgcolor: "#ffe3b5ff",
                },

                //   "&:hover .icon": {
                //     transform: "scale(1.15)",
                //   },

                "&:hover .title": {
                  color: "#F29C24",
                },
              }}
            >
              <Stack sx={{}} spacing={2}>
                <Box
                  className="icon-box"
                  sx={{
                    height: "60px",
                    width: "60px",
                    background: "linear-gradient(104deg, #f09823, #d87113)",
                    borderRadius: "15px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: "all 0.3s ease",
                  }}
                >
                  <MailIcon
                    className="icon"
                    sx={{ fontSize: 30, color: "white" }}
                  />
                </Box>
                <Typography
                  className="title"
                  variant="h5"
                  sx={{
                    fontSize: "19px",
                    fontWeight: 800,
                    transition: "color 0.3s ease",
                  }}
                >
                  Email Us
                </Typography>
                <Box>
                  <Typography
                    sx={{ color: "#595959ff", fontSize: "14px", mt: 1 }}
                  >
                    {CONTACT_INFO.email}
                  </Typography>
                  <Typography sx={{ color: "#595959ff", fontSize: "14px" }}>
                    We Replay within 24hrs
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Grid>
          <Grid item size={{ xs: 12, md: 3 }}>
            <Box
              sx={{
                borderRadius: "15px",
                p: 3,
                background: "white",
                display: "flex",
                cursor: "pointer",

                boxShadow: "0 5px 12px rgba(0,0,0,0.08)",
                opacity: show ? 1 : 0,
                transform: show
                  ? "scale(1) translateY(0)"
                  : "scale(0.88) translateY(25px)",
                transition: "all 0.55s ease",
                transitionDelay: "0.48s",

                "&:hover": {
                  transform: "translateY(-5px)", // little pop up
                  boxShadow: "0 12px 30px rgba(247, 206, 149, 0.8)",
                },

                "&:hover .icon-box": {
                  transform: "scale(1.12)",
                  bgcolor: "#ffe3b5ff",
                },

                //   "&:hover .icon": {
                //     transform: "scale(1.15)",
                //   },

                "&:hover .title": {
                  color: "#F29C24",
                },
              }}
            >
              <Stack sx={{}} spacing={2}>
                <Box
                  className="icon-box"
                  sx={{
                    height: "60px",
                    width: "60px",
                    background: "linear-gradient(104deg, #f09823, #d87113)",
                    borderRadius: "15px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    transition: "all 0.3s ease",
                  }}
                >
                  <AccessTimeOutlinedIcon
                    className="icon"
                    sx={{
                      color: "white",
                      fontSize: 36,
                      transition: "transform 0.3s ease",
                    }}
                  />
                </Box>
                <Typography
                  className="title"
                  variant="h5"
                  sx={{
                    fontSize: "19px",
                    fontWeight: 800,
                    transition: "color 0.3s ease",
                  }}
                >
                  Opening Hours
                </Typography>
                <Box>
                  <Typography
                    sx={{ color: "#595959ff", fontSize: "14px", mt: 1 }}
                  >
                    Mon - Sat: 9am - 10pm
                  </Typography>
                  <Typography sx={{ color: "#595959ff", fontSize: "14px" }}>
                    Sunday: 9:30am-9:30pm
                  </Typography>
                </Box>
              </Stack>
            </Box>
          </Grid>
        </Grid>
        <Typography>
          Follow us for daily inspiration, behind-the-scenes, and special
          offers!
        </Typography>
        <Box
          sx={{
            display: "flex",
            background: "linear-gradient(104deg, #f09823, #d87113)",
            height: 170,
            width: "90%",
            borderRadius: 7,
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 1,
            p: 2,
          }}
        >
          <Typography variant="h5" sx={{ color: "white", fontWeight: 600 }}>
            Prefer to Chat?
          </Typography>
          <Typography color="white" sx={{ fontWeight: 300, fontSize: 15 }}>
            Send us a message on WhatsApp for quick responses!
          </Typography>
          <Button
            onClick={openWhatsApp}
            sx={{
              borderRadius: 20,
              bgcolor: "white",
              color: "black",
              height: 47,
              p: 2,
              textTransform: "none",
              boxShadow: "0 6px 16px rgba(0,0,0,0.25)",
            }}
          >
            <ChatBubbleOutlineIcon sx={{ fontSize: "16px", mr: 2 }} />
            Start WhatsApp Chat
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
